// @module NXTurn.ShoppingExtensions.NewArrivals
define('C3.ShoppingExtensions.NewArrivals.View'
,   [
    'c3_shoppingextensions_newarrivals.tpl'
    
    //, 'NXTurn.ShoppingExtensions.NewArrivals.SS2Model'
    , 'C3.ShoppingExtensions.NewArrivals.Correlated.View'
    , 'GlobalViews.Pagination.View'
   // ,  'SC.Configuration'
    , 'Backbone.CollectionView'
    ,  'C3.ShoppingExtensions.NewArrivals.ItemCellView'
    ,  'facets_item_cell_grid.tpl'
    ,  'facets_items_collection_view_cell.tpl'
    ,  'facets_items_collection_view_row.tpl'
    ,   'facets_items_collection.tpl'
    ,  'GlobalViews.Breadcrumb.View'
    ,   'Backbone.CompositeView'
    ,   'Backbone'
    ,  'Utils'
    ]
, function (
    c3_shoppingextensions_newarrivals_tpl
    
    //, NewArrivalsSS2Model
    , ItemRelationsCorrelatedView
    , GlobalViewsPaginationView
   // ,  Configuration
    ,  BackboneCollectionView
    ,  NewArrivalsItemCellView
    ,  facets_item_cell_grid_tpl
    ,  facets_items_collection_view_cell_tpl
    ,  facets_items_collection_view_row_tpl
    ,  facets_items_collection_tpl
    ,  GlobalViewsBreadcrumbView
    ,  BackboneCompositeView
    ,   Backbone
    , Utils
)
{
    'use strict';

    // @class NXTurn.ShoppingExtensions.NewArrivals.View @extends Backbone.View
    return Backbone.View.extend({

        template: c3_shoppingextensions_newarrivals_tpl

    ,   initialize: function (options) {
            //console.log(options)
            this.options = options;
            this.application = options.application;
            this.configuration = options.configuration;

            this.listenCollection();

            var url_options = Utils.parseUrlOptions(Backbone.history.fragment)
        
            this.page = url_options.page


            BackboneCompositeView.add(this);
        }


        ,   listenCollection: function ()
        {
            this.setLoading(true);

            this.collection.on({
                request: jQuery.proxy(this, 'setLoading', true)
            ,   reset: jQuery.proxy(this, 'setLoading', false)
            });
        }
        
    ,   setLoading: function (value)
        {
            this.isLoading = value;
        }       

    ,   events: {
        'click [data-action="download-newarrvials-results"]': 'downloadCSV'
        }

    ,   bindings: {
        }


    ,   downloadCSV: function()
    {
        var savedSearchId = 'customsearch_new_arrivals'
        ,   downloadLabel = 'New Arrivals'
        
        //var url = "https://4953269.extforms.netsuite.com/app/site/hosting/scriptlet.nl?script=1300&deploy=1&compid=4953269&h=7a0eb1a4a297a9db9288&searchinternalid="+savedSearchId+"&downloadFileLabel="+downloadLabel;
        var url = "https://4953269.extforms.netsuite.com/app/site/hosting/scriptlet.nl?script=1300&deploy=1&compid=4953269&ns-at=AAEJ7tMQLKoI0DxUUlBnv_Re5QQLqJMGG0DVELVaN6-AFmU7jSQ&searchinternalid="+savedSearchId+"&downloadFileLabel="+downloadLabel;
        window.location.href = url;
    }
    

      , childViews: {
      'Correlated.Items': function ()
      {
        /*return new ItemRelationsCorrelatedView({
          itemsIds: this.collection.get('ids')
        , application: this.application
        });*/
      },
      'Global.Breadcrumb': function() {
                var ieBreadcrumbs = [];

                 ieBreadcrumbs[0] = {
                        href : '/',
                        'data-hashtag' : '#',
                        'data-touchpoint': "home",
                        hasDataHashtag: true,
                        hasDataTouchpoint: true,
                        text: "Home"
                  }

                ieBreadcrumbs[1] = {
                     href : '/',
                     text: "New Arrivals"
                }

                return new GlobalViewsBreadcrumbView({
                         pages: ieBreadcrumbs 
                    });
            },
      'GlobalViews.Pagination': function() {
        
        var pagesFound = this.collection.totalRecordsFound;
        //console.log(this.collection)
            var Pagination = new GlobalViewsPaginationView(_.extend({
                            totalPages: Math.ceil(this.collection.totalRecordsFound / this.collection.recordsPerPage)
                        }, this.configuration.defaultPaginationSettings));
            //console.log(Pagination)
                   return Pagination;
        }
        ,
      'NewArrival.Items': function() {

            var isPhoneDevice = Utils.isPhoneDevice()
                        ,   viewsPerRow = 4;

                        if(isPhoneDevice)
                        viewsPerRow = 2;

            return new BackboneCollectionView({
                application: this.application,
               /* keywords: this.translator.getOptionValue('keywords'),*/
                collection: this.collection.models,
                viewsPerRow: viewsPerRow,
                childTemplate: facets_item_cell_grid_tpl,
                childView: NewArrivalsItemCellView,
                cellTemplate: facets_items_collection_view_cell_tpl,
                rowTemplate: facets_items_collection_view_row_tpl,
                template: facets_items_collection_tpl,
                childViewOptions:{
                    origin: 'newarrivals-page',
                    configuration : this.configuration,
                    application : this.application
                }
            });
        }
    }

  , getContext: function ()
    {
            //NewArrivals Date Range
            var NewArrivalsDateObj = new Date()
            ,   NewArrivalsTodaysDate = NewArrivalsDateObj.getDate()
            ,   NewArrivalsTodaysMonth = NewArrivalsDateObj.getMonth()+1
            ,   NewArrivalsTodaysDay = NewArrivalsDateObj.getDay()
            ,   NewArrivalsFinalThisDate = NewArrivalsTodaysMonth+"/"+NewArrivalsTodaysDate

            var NewArrivalsOneWeekAgo = new Date();
            NewArrivalsOneWeekAgo.setDate(NewArrivalsOneWeekAgo.getDate() - 6);
            var NewArrivalsOneWeekAgoDate = NewArrivalsOneWeekAgo.getDate()
            ,   NewArrivalsOneWeekAgoMonth = NewArrivalsOneWeekAgo.getMonth()+1
            ,   NewArrivalsFinalOneWeekAgoDate = NewArrivalsOneWeekAgoMonth+"/"+NewArrivalsOneWeekAgoDate

            var newArrivalsDateRange = NewArrivalsFinalOneWeekAgoDate+"-"+NewArrivalsFinalThisDate;

      return {
     newArrivalsDateRange : newArrivalsDateRange
      }
    }
    });
});
